var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ stake: true, selected: _vm.isSelected },on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }